
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { themes } from "mdx-deck";
export const theme = { ...themes.dark,
  styles: {
    p: {
      fontWeight: 100
    },
    li: {
      fontWeight: 100,
      marginTop: "5pt"
    },
    a: {
      fontWeight: 100,
      color: "#00A699",
      textDecoration: "none"
    }
  }
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`技术人的职业发展和个人成长`}</h1>
    <p>{`Dora Hacks ↔️ Jiayu Liu`}</p>
    <p><inlineCode parentName="p">{`https://tech-growth.now.sh`}</inlineCode></p>
    <p>{`2020 年 7 月 31 日`}</p>
    <hr></hr>
    <h1>{`关于我`}</h1>
    <hr></hr>
    <h1>{`十个话题`}</h1>
    <ol>
      <li parentName="ol">{`Identity 身份认同`}</li>
      <li parentName="ol">{`Growth mindset 增长心态`}</li>
      <li parentName="ol">{`Efficiency 效率`}</li>
      <li parentName="ol">{`Fundamentals 基本面`}</li>
      <li parentName="ol">{`Abstractions 抽象层`}</li>
      <li parentName="ol">{`Leverages 杠杆`}</li>
      <li parentName="ol">{`Long-term relationship 长线人际关系`}</li>
      <li parentName="ol">{`Communications as skills 沟通即技能`}</li>
      <li parentName="ol">{`Optimism and calculated risk 乐观中冒险`}</li>
      <li parentName="ol">{`Giving back 回馈`}</li>
    </ol>
    <hr></hr>
    <h2>{`Identity 身份认同`}</h2>
    <p><a parentName="p" {...{
        "href": "https://book.douban.com/subject/25985021/"
      }}>{`人类简史`}</a>{` / `}<a parentName="p" {...{
        "href": "https://book.douban.com/subject/26943161/"
      }}>{`未来简史`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.paulgraham.com/identity.html"
      }}>{`Keep your identity small`}</a></p>
    <hr></hr>
    <h2>{`Growth mindset 增长心态`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.tesla.com/blog/master-plan-part-deux"
      }}>{`Elon Musk 的十年计划`}</a></p>
    <p>{`Normal distributions aren't normal`}</p>
    <p>{`Power law / Zipf's law / VC's Portfolio`}</p>
    <hr></hr>
    <h2>{`Efficiency 效率`}</h2>
    <p><a parentName="p" {...{
        "href": "https://prettier.io"
      }}>{`prettier`}</a>{` / `}<a parentName="p" {...{
        "href": "https://github.com/psf/black"
      }}>{`black`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://www.paulgraham.com/vb.html"
      }}>{`人生苦短`}</a></p>
    <hr></hr>
    <h2>{`Fundamentals 基本面`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/denoland/deno/issues/25"
      }}>{`「学不动了」`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/ry"
      }}>{`Ryan Dahl`}</a>{`: Node.js, Deno, `}<a parentName="p" {...{
        "href": "https://tinyclouds.org/residency"
      }}>{`Google Brain`}</a></p>
    <p>{`IP and ⏳ hourglass`}</p>
    <hr></hr>
    <h2>{`Abstractions 抽象层`}</h2>
    <p><a parentName="p" {...{
        "href": "https://cdecl.org/?q=void*%28*x%29%28void*%29"
      }}><inlineCode parentName="a">{`void*(*x)(void*)`}</inlineCode></a></p>
    <p><a parentName="p" {...{
        "href": "https://m.douban.com/book/subject/6811366/"
      }}>{`禅与摩托车维修艺术`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Indirection"
      }}>{`All problems in computer science can be solved by another level of indirection`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.joelonsoftware.com/2002/11/11/the-law-of-leaky-abstractions/"
      }}>{`The law of leaky abstractions`}</a></p>
    <hr></hr>
    <h2>{`Leverages 杠杆`}</h2>
    <p><a parentName="p" {...{
        "href": "https://nav.al/product-media/"
      }}>{`三种 leverage`}</a></p>
    <p>{`permissioned / permissionless`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.goodreads.com/quotes/681-the-future-is-already-here-it-s-just-not-evenly"
      }}>{`The future is already here – it's just not evenly distributed.`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/openai/gpt-3"
      }}>{`GPT-3`}</a>{`, e.g. `}<a parentName="p" {...{
        "href": "https://twitter.com/sharifshameem/status/1282676454690451457?s=20"
      }}>{`React`}</a></p>
    <hr></hr>
    <h2>{`Long-term relationship 长线人际关系`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.goodreads.com/quotes/1798-you-are-the-average-of-the-five-people-you-spend"
      }}>{`You are the average of the five people you spend the most time with.`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/PayPal_Mafia"
      }}>{`Tesla / LinkedIn / Palantir / SpaceX / YouTube / Yelp`}</a></p>
    <hr></hr>
    <h2>{`Communications as skills 沟通即技能`}</h2>
    <p>{`了解你的听众`}</p>
    <p>{`同步 / 异步`}</p>
    <p>{`unicast / multicast`}</p>
    <hr></hr>
    <h2>{`Optimism and calculated risk 乐观中冒险`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.fooledbyrandomness.com/"
      }}>{`期权，非对称性，黑天鹅，NN Taleb`}</a></p>
    <hr></hr>
    <h2>{`Giving back 回馈`}</h2>
    <p>{`开源社区`}</p>
    <p><a parentName="p" {...{
        "href": "http://worrydream.com/#!/ClimateChange"
      }}>{`气候变化`}</a>{` / `}<a parentName="p" {...{
        "href": "https://www.kaggle.com/andradaolteanu/birdcall-recognition-eda-and-audio-fe"
      }}>{`鸟鸣识别`}</a></p>
    <hr></hr>
    <p><inlineCode parentName="p">{`📧 jiayu@hey.com`}</inlineCode></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;